import {useDebugValue} from 'react';

import classNames from 'classnames';

import {
    useSearchFormContext,
    useTrackingContext
} from '../../../hooks';

import {
    showFormSummary,
    submitForm
} from '../../../utils';

const componentClassName = 'search-form';

function useComponent() {
    const {
        systemOptions,
        mediaSettings,
        abacusStore,
        edapOptions,
        latestSearchValues,
        formActions,
        formEvents,
        formOptions,
        formOptions: {
            layout,
            align
        },
        destinationActions,
        latestDestinationValues,
        latestDatesValues,
        latestGuestsValues
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();

    const layoutClassName = `${componentClassName}--${layout}`;
    const alignClassName = `${componentClassName}--${align}`;

    const className = classNames(componentClassName, layoutClassName, alignClassName);

    const showSummary = showFormSummary(mediaSettings, formOptions);

    function handleSubmit(event) {
        event.preventDefault();

        submitForm(trackingContext, systemOptions, abacusStore, edapOptions, latestSearchValues, formActions, formEvents, destinationActions, latestDestinationValues, latestDatesValues, latestGuestsValues);
    }

    const result = {
        className,
        showSummary,
        onSubmit: handleSubmit
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
